import styled from "styled-components";

export const ConcernCanvas = styled.canvas`
    width: 100%;
    object-fit: contain;
    aspect-ratio: 3/4;
    background-color: #FAFAFA;

    @media (max-width: 768px){
        aspect-ratio: 3/4;
    }
`;

export const ConcernRender = styled.img`
    width: 100%;
    object-fit: contain;
    aspect-ratio: 3/4;
    background-color: #FAFAFA;

    @media (max-width: 768px){
        aspect-ratio: 3/4;
    }
`;

export const ChosenConcernCanvas = styled.canvas`
    width: 45%;
    height: auto;
    object-fit: contain;
    background-color: #FAFAFA;
    
    @media (max-width: 768px) {
        width: 100%;
        aspect-ratio: 3/4;
    }
`;

export const UVConcernCanvas = styled.canvas`
    width: 45%;
    height: auto;
    object-fit: contain;
    background-color: #FAFAFA;

    @media (max-width: 768px) {
        width: 100%;
        aspect-ratio: 3/4;
    }
`;

export const AnalysisConcernCanvas = styled.canvas`
    width: 100%;
    max-height: 500px;
    object-fit: contain;
    aspect-ratio: 3/4;
    background-color: #FAFAFA;
`;
